<template>
    <form id="loader" class="payment-result-form" :style="'display:' + show">
        <div name="loader-container" class="row">
            <div class="loader-container">
              <img src="@/assets/Loading_icon.gif" class="loader-icon" width="250" height="150" alt="Loading..."/>
            </div>
        </div>
        <h3 style="margin-top:-15px;">Transaction in progress</h3>
    </form>
</template>
<!-- Scripts-->
<script>
export default {
  name: "LoaderForm",
  data() {
    return {
      showLoader: "",
    };
  },
  props: {
    display: String,
  },
  computed: {
    show: function () {
      if(this.showLoader)
        return this.showLoader;

      return this.display;
    }
  },
  methods: {
      showForm(bool){
          this.showLoader = bool?"block":"none";
      },
  },
  created() {

  },
  mounted() {   
    
  }
};
</script>
<!-- Styles -->
<style scoped>
</style>